import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { ExpandCircleDownOutlined } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Box, List, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import "../assets/styles/plans.css";
import { colors } from "./ui/colors";

const MAX_BENEFITS_PER_COLUMN = 5;
const MAX_COLUMNS = 3;

export const PlanCheckoutTicket = ({ title, planSelected }) => {
  const isFreePlan = planSelected?.name?.toLowerCase() === "free";
  const bannerColor = colors.orange.base;

  return (
    <Box
      className="summary"
      sx={{
        borderColor: "grey.500",
        borderRadius: 1,
        display: "flex",
        flexDirection: "column",
        minWidth: 0,
        width: "100%",
        overflow: "hidden",
      }}
    >
      <Typography variant="h5" color="primary.main" sx={{ fontWeight: "bold" }}>
        {title}
      </Typography>

      <Accordion
        defaultExpanded
        disableGutters
        sx={{
          bgcolor: "transparent",
          boxShadow: "none",
          mt: isFreePlan ? 1.5 : 1,
          "&::before": { display: "none" },
          "&.Mui-expanded": { margin: 0 },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandCircleDownOutlined sx={{ color: bannerColor }} />}
          sx={{
            minHeight: 36,
            px: 0,
            "& .MuiAccordionSummary-content": { my: 0.5 },
          }}
        >
          <Typography variant="subtitle2" color="primary.main" sx={{ fontWeight: "bold" }}>
            {`ADVANTAGES OF THE ${planSelected?.name?.toUpperCase()} PLAN (What's Included)`}
          </Typography>
        </AccordionSummary>

        <AccordionDetails sx={{ px: 0, pt: 0 }}>
          {(() => {
            const benefits = planSelected?.benefits ?? [];

            const numColumns = Math.min(
              MAX_COLUMNS,
              benefits.length <= MAX_BENEFITS_PER_COLUMN ? 1 : Math.ceil(benefits.length / MAX_BENEFITS_PER_COLUMN),
            );

            const itemsPerColumn = numColumns === 1 ? benefits.length : Math.ceil(benefits.length / numColumns);

            const columns = Array.from({ length: numColumns }, (_, i) =>
              benefits.slice(i * itemsPerColumn, Math.min((i + 1) * itemsPerColumn, benefits.length)),
            );

            return (
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: {
                    xs: "1fr",
                    sm: "repeat(2, minmax(180px, 1fr))",
                    md: `repeat(${numColumns}, minmax(180px, 1fr))`,
                  },
                  gap: 1.5,
                  minWidth: 0,
                }}
              >
                {columns.map((columnBenefits, colIndex) => (
                  <List key={colIndex} dense sx={{ minWidth: 0, overflow: "hidden" }}>
                    {columnBenefits.map((benefit, index) => (
                      <ListItem
                        key={`${colIndex}-${index}`}
                        sx={{
                          minWidth: 0,
                          alignItems: "flex-start",
                          py: 0.35,
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 20,
                            mt: "7px",
                          }}
                        >
                          <Box
                            sx={{
                              width: 6,
                              height: 6,
                              borderRadius: "50%",
                              bgcolor: "info.main",
                            }}
                          />
                        </ListItemIcon>

                        <ListItemText
                          primary={
                            <Typography
                              variant="body2"
                              sx={{
                                overflowWrap: "break-word",
                                wordBreak: "break-word",
                                lineHeight: 1.45,
                              }}
                            >
                              {benefit}
                            </Typography>
                          }
                        />
                      </ListItem>
                    ))}
                  </List>
                ))}
              </Box>
            );
          })()}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};
